"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _GroupComponent = _interopRequireDefault(require("./GroupComponent"));
var _OrderSummaryComponent = _interopRequireDefault(require("./OrderSummaryComponent"));
var _DisclaimerComponent = _interopRequireDefault(require("./DisclaimerComponent"));
var _StickyComponent = _interopRequireDefault(require("./StickyComponent"));
var _reactSticky = require("react-sticky");
var _storeProvider = require("./../util/storeProvider");
var _common = require("./../util/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class PageComponent extends _react.PureComponent {
  render() {
    const {
      colClass,
      showOrderSummary,
      continueButtonDiv,
      scrollToCartText,
      currentPage,
      pages
    } = this.props;
    if (pages.length === 0 || Object.keys(pages).length === 0) return null;
    const {
      page: pageName,
      groups,
      content
    } = pages[currentPage];
    const title = {
      __html: content.title
    };
    const description = {
      __html: content.description
    };
    return /*#__PURE__*/React.createElement(_react.Fragment, null, title && /*#__PURE__*/React.createElement("h2", {
      dangerouslySetInnerHTML: title
    }), description && /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: description
    }), /*#__PURE__*/React.createElement(_reactSticky.StickyContainer, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: colClass
    }, groups && groups.filter(group => group.layoutProperties.display !== 'none').filter(group => group.attributes.length > 0).map(group => {
      return /*#__PURE__*/React.createElement(_GroupComponent.default, _extends({
        includeState: [{
          path: 'app.postComplete'
        }, {
          path: 'app.content',
          propKey: 'commonContent'
        }],
        key: `${pageName}.${(0, _common.getInstancePathKey)(group.group, group.attributes[0].propertytype)}`
      }, group, {
        pageName: pageName
      }));
    })), showOrderSummary && /*#__PURE__*/React.createElement("div", {
      className: "col-sm-12 col-xl-4 order-summary"
    }, /*#__PURE__*/React.createElement(_StickyComponent.default, {
      continueButtonDiv: continueButtonDiv,
      text: scrollToCartText
    }, /*#__PURE__*/React.createElement(_OrderSummaryComponent.default, {
      includeState: [{
        path: 'orderSummary'
      }, {
        path: 'app.content',
        propKey: 'commonContent'
      }],
      content: content,
      groups: groups
    }))))), /*#__PURE__*/React.createElement(_DisclaimerComponent.default, content), this.props.continueButton);
  }
}
exports.PageComponent = PageComponent;
PageComponent.propTypes = {
  scrollToCartText: _propTypes.default.string,
  showOrderSummary: _propTypes.default.bool,
  continueButton: _propTypes.default.object,
  continueButtonDiv: _propTypes.default.object,
  colClass: _propTypes.default.string,
  currentPage: _propTypes.default.number,
  pages: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.object)]),
  content: _propTypes.default.shape({
    'product-name': _propTypes.default.string,
    'product-description': _propTypes.default.string,
    'title': _propTypes.default.string,
    'description': _propTypes.default.string
  })
};
var _default = exports.default = (0, _storeProvider.provideContext)(PageComponent);